import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Notes } from 'components/common/Notes'
import { toFormData, toGroupOptions } from 'components/Deal/serializers'
import { AddNoteModal } from 'components/common/modals/AddNoteModal'
import { makeGetRequest } from 'utils/api'
import * as ACT from 'components/Deal/actions'
import { useParams } from 'react-router-dom'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import swal from 'sweetalert'

const DealNotes = ({ notes }) => {
  const [showAddNoteModal, setShowAddNoteModal] = useState(false)
  const [selectedNote, setSelectedNote] = useState(null)
  const [contacts, setContacts] = useState([])
  const { id } = useParams()

  const dispatch = useDispatch()

  const groupedContacts = toGroupOptions(contacts)

  const toggleAddNoteModal = selectedNote => {
    setShowAddNoteModal(!showAddNoteModal)
    setSelectedNote(selectedNote)
  }

  const addNote = (cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.DEAL_ADD_NOTE_REQUESTED,
      payload: {
        data: toFormData(contact, files, note, id, dateEntered)
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const updateNote = (noteId, cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.DEAL_UPDATE_NOTE_REQUESTED,
      payload: {
        data: toFormData(contact, files, note, id, dateEntered),
        noteId
      }
    })
    destroyEditor?.()
    cb?.()
  }

  useEffect(() => {
    id &&
      (async () => {
        const response = await makeGetRequest(`/v1/deals/${id}/allContacts`)
        setContacts(response)
      })()
  }, [id, dispatch])

  const deleteNote = async noteId => {
    const willRemove = await swal({
      title: 'Are you sure you want to delete this note?',
      text: 'This action can’t be undone',
      buttons: ['Cancel', 'Yes'],
      icon: 'warning'
    })
    if (willRemove) {
      try {
        dispatch({
          type: ACT.DEAL_DELETE_NOTE_REQUESTED,
          payload: {
            noteId
          }
        })
      } catch (e) {
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: {
            title: 'There was a problem deleting note',
            level: 'error'
          }
        })
      }
    }
  }

  return (
    <div style={{ overflow: 'hidden' }}>
      <AddNoteModal
        toggleAddNoteModal={toggleAddNoteModal}
        showAddNoteModal={showAddNoteModal}
        selectedNote={selectedNote}
        groupedContacts={groupedContacts}
        addNote={addNote}
        updateNote={updateNote}
      />
      <Notes notes={notes} toggleAddNoteModal={toggleAddNoteModal} deleteNote={deleteNote} />
    </div>
  )
}

export default DealNotes
